import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./modules/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'DASHBOARD' }
      },
      {
        path: 'products',
        loadComponent: () => import('./modules/products/products.component').then(m => m.ProductsComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'PRODUCTS' }
      },
      {
        path: 'recipes',
        loadComponent: () => import('./modules/recipes/recipes.component').then(m => m.RecipesComponent)
      },
      {
        path: 'orders',
        loadComponent: () => import('./modules/orders/orders.component').then(m => m.OrdersComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'ORDERS' }
      },
      {
        path: 'scheduler',
        loadComponent: () => import('./modules/scheduler/scheduler.component').then(m => m.SchedulerComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'SCHEDULER' }
      },
      {
        path: 'users',
        loadComponent: () => import('./modules/users/users.component').then(m => m.UsersComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'USER_MANAGEMENT' }
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
